<div class="container-fluid" >
    <div class="row header-oferta">
        <div class="col-md-6">
            <div class="row">
                <div class="col-2">
                    <ngx-avatar size="40"  src="assets/images/general/avatar.png"></ngx-avatar>
                   </div>
                   <div class="col-10">
                        <h4>{{clienteserviceParam.datosCliente.cliente.nombreCompleto|accentMark: false }}</h4>
                        <p>Código Cliente: {{clienteserviceParam.datosCliente.cliente.codigoClienteBantrab}}</p>
                        <p>Score predictivo {{this.clienteserviceParam.datosPrecalificacion.segmento!='PV'?'interno':''}} deudor: {{ clienteserviceParam.debtorScore|number:'1.0-0' }}</p>
                        <p *ngIf="clienteserviceParam.coDebtorScore !== '0' && clienteserviceParam.coDebtorScore !== '0.0' && clienteserviceParam.flowType === 'CODEBTOR'">Score predictivo {{this.clienteserviceParam.datosPrecalificacion.segmento!='PV'?'interno':''}} codeudor: {{ clienteserviceParam.coDebtorScore|number:'1.0-0' }}</p>
                   </div>
            </div>
        </div>
        <div class="col-md-6">
        </div>
        <h2 *ngIf="!onlyoneflag">Seleccione una oferta</h2>
    </div>
    <div class="oferta" *ngIf="!onlyoneflag">
        <div  class="row">
            <div class="col-md-3">
                <h1>{{clienteserviceParam.ofertasComerciales.ofertaComercial[ofertaseleccionada].tipo}}</h1>
            </div>
            <div class="col-md-8">
                <div class="row" style="padding: 0 10px 0 10px;" >
                    <div class="col-md-6">
                        <h2><strong>Líquido a recibir</strong></h2>
                        <h3>Monto</h3>
                        <h3>Cuota con seguro</h3>
                        <h3>Plazo</h3>
                        <h3>Tasa anual</h3>
                        <h3 *ngIf="clienteserviceParam.datosPrecalificacion.segmento!='PV'">RCI interno final deudor</h3>
                        <h3>RCI global final deudor</h3>
                        <h3 *ngIf="clienteserviceParam.flowType === 'CODEBTOR' && clienteserviceParam.datosPrecalificacion.segmento=='PV'">RCI interno final codeudor</h3>
                        <h3 *ngIf="clienteserviceParam.flowType === 'CODEBTOR'">RCI global final codeudor</h3>
                    </div>
                    <div class="col-md-6">
                        <h2 style="text-align: right;"><strong>{{clienteserviceParam.ofertasComerciales.ofertaComercial[ofertaseleccionada].liquidezRecibir| currency:"Q "}}</strong></h2>
                        <h2 style="text-align: right;">
                            {{clienteserviceParam.ofertasComerciales.ofertaComercial[ofertaseleccionada].monto|
                                currency:"Q "}}
                        </h2>
                        <h2 style="text-align: right;">{{clienteserviceParam.ofertasComerciales.ofertaComercial[ofertaseleccionada].cuotaNuevoCreditoConSeguro| currency:"Q "}}</h2>
                        <h2 style="text-align: right;">{{clienteserviceParam.ofertasComerciales.ofertaComercial[ofertaseleccionada].plazo}} meses</h2>
                        <h2 style="text-align: right;">{{ clienteserviceParam.ofertasComerciales.ofertaComercial[ofertaseleccionada].tasa|number:'1.2-2' }}%</h2>
                      <h2 style="text-align: right;" *ngIf="clienteserviceParam.datosPrecalificacion.segmento!='PV'">
                        {{ clienteserviceParam.ofertasComerciales.ofertaComercial[ofertaseleccionada].rciInternoFinalDeudor|number: '1.2-2' }}%
                      </h2>
                      <h2 style="text-align: right;">
                        {{ clienteserviceParam.ofertasComerciales.ofertaComercial[ofertaseleccionada].rciGlobalFinalDeudor|number:'1.2-2' }}%
                      </h2>
                      <h2 style="text-align: right;" *ngIf="clienteserviceParam.flowType === 'CODEBTOR' && clienteserviceParam.datosPrecalificacion.segmento!='PV'">
                        {{ clienteserviceParam.ofertasComerciales.ofertaComercial[ofertaseleccionada].rciInternoFinalFiador|number: '1.2-2' }}%
                      </h2>
                      <h2 style="text-align: right;" *ngIf="clienteserviceParam.flowType === 'CODEBTOR'">
                        {{ clienteserviceParam.ofertasComerciales.ofertaComercial[ofertaseleccionada].rciGlobalFinalFiador|number:'1.2-2' }}%
                      </h2>
                    </div>
                </div>
                <h4 style="text-align: center;margin:15px 0 15px 0;">Descuentos del crédito</h4>
                <div  class="row" style="padding: 0 25px 0 25px;" >
                    <div class="col-md-6 p-0">
                        <h3>Comisión por desembolso</h3>
                        <h3>Prima Seguro anual</h3>
                        <h3>Interés fin de mes</h3>
                        <h3 *ngIf="clienteserviceParam.TotalCosolidacion>0">Consolidación</h3>
                    </div>
                    <div class="col-md-6 p-0">
                        <h2 style="text-align: right;">{{clienteserviceParam.ofertasComerciales.ofertaComercial[ofertaseleccionada].comisionDesembolso| currency:"Q "}}</h2>
                        <h2 style="text-align: right;">{{clienteserviceParam.ofertasComerciales.ofertaComercial[ofertaseleccionada].primaSeguroAnual| currency:"Q "}}</h2>
                        <h2 style="text-align: right;">{{clienteserviceParam.ofertasComerciales.ofertaComercial[ofertaseleccionada].interesFinDeMes| currency:"Q "}}</h2>
                        <h2 *ngIf="clienteserviceParam.TotalCosolidacion>0" style="text-align: right;">{{clienteserviceParam.TotalCosolidacion|
                            currency:"Q "}}</h2>
                    </div>
                </div>
            </div>
            <div class="col-md-1">
                <div class="custom-control custom-switch">
                    <input *ngIf="ofertaseleccionadacliente!=ofertaseleccionada" type="checkbox" (change)="selectOferta(ofertaseleccionada)" class="custom-control-input" id="{{ofertaseleccionada}}">
                    <input *ngIf="ofertaseleccionadacliente==ofertaseleccionada" type="checkbox" (change)="selectOferta(ofertaseleccionada)" class="custom-control-input" id="{{ofertaseleccionada}}" checked disabled>
                    <label class="custom-control-label" for="{{ofertaseleccionada}}"></label>
                </div>
            </div>
        </div>
    </div>
    <hr *ngIf="!onlyoneflag" style="text-align: center; background-image: linear-gradient(90deg, #00abb6 15%, #05718f 56%) !important; color: #fff;height: 4px;box-shadow: 0px 5px 12px 0px rgb(0 0 0 / 44%);">
    <div class="oferta" >
        <div class="row">
            <div class="col-md-3">
                <h1>{{clienteserviceParam.ofertasComerciales.ofertaComercial[ofertamym].tipo}}</h1>
            </div>
            <div class="col-md-8">
                <div class="row" style="padding: 0 10px 0 10px;" >
                    <div class="col-md-6">
                        <h2><strong>Líquido a recibir</strong></h2>
                        <h3>Monto</h3>
                        <h3>Cuota con seguro</h3>
                        <h3>Ahorro mensual</h3>
                        <h3>Cuota total mensual</h3>
                        <h3>Plazo</h3>
                        <h3>Tasa anual</h3>
                        <h3 *ngIf="clienteserviceParam.datosPrecalificacion.segmento!='PV'">RCI interno final deudor</h3>
                        <h3>RCI global final deudor</h3>
                        <h3 *ngIf="clienteserviceParam.flowType === 'CODEBTOR' && clienteserviceParam.datosPrecalificacion.segmento=='PV'">RCI interno final codeudor</h3>
                        <h3 *ngIf="clienteserviceParam.flowType === 'CODEBTOR'">RCI global final codeudor</h3>
                    </div>
                    <div class="col-md-6">
                        <h2 style="text-align: right;"><strong>{{clienteserviceParam.ofertasComerciales.ofertaComercial[ofertamym].liquidezRecibir| currency:"Q "}}</strong></h2>
                        <h2 style="text-align: right;">
                            {{clienteserviceParam.ofertasComerciales.ofertaComercial[ofertamym].monto|
                                currency:"Q "}}
                        </h2>
                        <h2 style="text-align: right;">{{getcuotamym()| currency:"Q "}}</h2>
                        <h2 style="text-align: right;">{{clienteserviceParam.ofertasComerciales.ofertaComercial[ofertamym].bienestarMixAndMatchAhorroMensual| currency:"Q "}}</h2>
                        <h2 style="text-align: right;">{{clienteserviceParam.ofertasComerciales.ofertaComercial[ofertamym].cuotaNuevoCreditoConSeguro| currency:"Q "}}</h2>
                        <h2 style="text-align: right;">{{clienteserviceParam.ofertasComerciales.ofertaComercial[ofertamym].plazo}} meses</h2>
                        <h2 style="text-align: right;">{{ clienteserviceParam.ofertasComerciales.ofertaComercial[ofertamym].tasa|number:'1.2-2' }}%</h2>
                        <h2 style="text-align: right;" *ngIf="clienteserviceParam.datosPrecalificacion.segmento!='PV'">
                            {{ clienteserviceParam.ofertasComerciales.ofertaComercial[ofertamym].rciInternoFinalDeudor|number:'1.2-2'  }}%</h2>
                        <h2 style="text-align: right;">
                          {{ clienteserviceParam.ofertasComerciales.ofertaComercial[ofertamym].rciGlobalFinalDeudor|number:'1.2-2' }}%</h2>
                          <h2 style="text-align: right;" *ngIf="clienteserviceParam.flowType === 'CODEBTOR' && clienteserviceParam.datosPrecalificacion.segmento!='PV'">
                            {{ clienteserviceParam.ofertasComerciales.ofertaComercial[ofertamym].rciInternoFinalFiador|number: '1.2-2' }}%
                          </h2>
                          <h2 style="text-align: right;" *ngIf="clienteserviceParam.flowType === 'CODEBTOR'">
                            {{ clienteserviceParam.ofertasComerciales.ofertaComercial[ofertamym].rciGlobalFinalFiador|number:'1.2-2' }}%
                          </h2>
                    </div>
                </div>
                <h4 style="text-align: center;margin:15px 0 15px 0;">Descuentos del crédito</h4>
                <div  class="row" style="padding: 0 25px 0 25px;" >
                    <div class="col-md-6 p-0">
                        <h3>Comisión por desembolso</h3>
                        <h3>Prima Seguro anual</h3>
                        <h3>Interés fin de mes</h3>
                        <h3 *ngIf="clienteserviceParam.TotalCosolidacion>0">Consolidación</h3>
                    </div>
                    <div class="col-md-6 p-0">
                        <h2 style="text-align: right;">{{clienteserviceParam.ofertasComerciales.ofertaComercial[ofertamym].comisionDesembolso| currency:"Q "}}</h2>
                        <h2 style="text-align: right;">{{clienteserviceParam.ofertasComerciales.ofertaComercial[ofertamym].primaSeguroAnual| currency:"Q "}}</h2>
                        <h2 style="text-align: right;">{{clienteserviceParam.ofertasComerciales.ofertaComercial[ofertamym].interesFinDeMes| currency:"Q "}}</h2>
                        <h2 *ngIf="clienteserviceParam.TotalCosolidacion>0" style="text-align: right;">{{clienteserviceParam.TotalCosolidacion|
                            currency:"Q "}}</h2>
                    </div>
                </div>
            </div>
            <div class="col-md-1">
                <div class="custom-control custom-switch" *ngIf="!onlyoneflag">
                    <input *ngIf="ofertaseleccionadacliente!=ofertamym" type="checkbox" (change)="selectOferta(ofertamym)" class="custom-control-input" id="{{ofertamym}}">
                    <input *ngIf="ofertaseleccionadacliente==ofertamym" type="checkbox" (change)="selectOferta(ofertamym)" class="custom-control-input" id="{{ofertamym}}" checked disabled>
                    <label class="custom-control-label" for="{{ofertamym}}"></label>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-6">
            <div style="text-align: left;">
                <button class="btn round-button-back" (click)="goBack()">Regresar</button>
            </div>
        </div>
        <div class="col-md-6">
            <div style="text-align: right;">
                <button class="btn round-button" (click)="verificarOferta()">Continuar</button>
            </div>
        </div>
    </div>

</div>
